// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3c9d1aee","89":"62e689ad","372":"1375ca12","718":"8e9588db"}[chunkId] + ".chunk.js";
};